import * as angular from 'angular';
import * as _ from 'lodash';

import { ITemplateService } from '@services/index';
import { Template } from '@models/index';
import { Dispatcher, Store } from '../Store';
import * as TEMPLATES from './templates.constants';

import {
    loadTemplates,
    loadTemplatesSuccess,
    addTemplateSuccess,
    addTemplate,
    deleteTemplate,
    deleteTemplateSuccess
} from './templates.actions';

export interface TemplateCreationProperties {
    comment: string;
    groupGuid: string;
    includeChildren: boolean;
    name: string;
}

export interface ITemplateActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<Template>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    create(target: TemplateCreationProperties): (dispatch: any, getState: () => Store) => angular.IPromise<Template>;
    // addOne(target: Template): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    // addMany(targets: Template[]): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    // updateOne(target: Template): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    // updateMany(targets: Template[]): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
    // deleteMany(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<Template[]>;
}

export class TemplatesActionsService implements ITemplateActionsService {

    static serviceId = 'templateActionsService';
    static $inject = ['$q', 'templateService'];

    constructor(
        private _$q: angular.IQService,
        private _templateService: ITemplateService
    ) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { templates } = getState();
            if (!templates.isLoading && !templates.isLoaded) {
                dispatch(loadTemplates());
                return this._templateService
                    .getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadTemplatesSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: TEMPLATES.TEMPLATES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<Template>(templates.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { templates } = getState();
            if (force || (!templates.isLoading && !templates.isLoaded)) {
                dispatch(loadTemplates());
                return this._templateService
                    .getAll(force)
                    .then(data => {
                        dispatch(loadTemplatesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TEMPLATES.TEMPLATES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Template>(templates.dictionary));
            }
        };
    }

    create(target: TemplateCreationProperties): Dispatcher<Template> {
        return (dispatch: any, getState: () => Store) => {
            const { templates } = getState();
            if (target) {
                dispatch(addTemplate(null));
                const { name, comment, groupGuid, includeChildren } = target;
                return this._templateService
                    .createTemplate(name, comment, groupGuid, includeChildren)
                    .then(data => {
                        const result = data;
                        dispatch(addTemplateSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: TEMPLATES.TEMPLATES_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Template>(templates.dictionary));
            }
        };
    }

    // addMany(targets: Template[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { templates } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(addTemplates(targets));
    //             return this._templateService.addTemplates(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(addTemplatesSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: TEMPLATES.TEMPLATES_ADD_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<Template>(templates.dictionary));
    //         }
    //     };
    // }

    // updateOne(target: Template) {
    //     return this.updateMany([target]);
    // }

    // updateMany(targets: Template[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { templates } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(updateTemplates(targets));
    //             return this._templateService.updateTemplates(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(updateTemplatesSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: TEMPLATES.TEMPLATES_UPDATE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<Template>(templates.dictionary));
    //         }
    //     };
    // }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { templates } = getState();
            if (guid) {
                dispatch(deleteTemplate(guid));
                return this._templateService
                    .delete(guid)
                    .then(data => {
                        const result = data;
                        dispatch(deleteTemplateSuccess(guid));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: TEMPLATES.TEMPLATE_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Template>(templates.dictionary));
            }
        };
    }

    // deleteMany(guids: string[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { templates } = getState();
    //         if (guids && guids.length > 0) {
    //             dispatch(deleteTemplates(guids));
    //             return this._templateService.deleteTemplates(guids)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(deleteTemplatesSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: TEMPLATES.TEMPLATES_DELETE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<Template>(templates.dictionary));
    //         }
    //     };
    // }
}